import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setcurrentLeadID, setCurrentPageTitle } from '../../../store/slices/pageSlice';
import { clearWizardState, goToStep, setCreatedProject } from '../../../store/slices/WizardSlice/wizardStepSlice';
import useMatchedProject from './useMatchedProject';
import useMatchedOperationsData from './useMatchedOperationsData';
import { setLeadReadTrue } from '../../../store/slices/readSlice';
import { fetchAllProjects } from '../../../store/slices/projectsSlice';
import DateConversion from '../../../utils/DateConversion';
import jsPDF from 'jspdf';
import { useCurrencySymbol } from '../../../utils/currencyUtils';
import CommaConvert from '../../../utils/CommaConvert';
import { formatAmountComma } from '../../../utils/decimalAmountUtils';
import { fetchDescriptionTasks } from '../../../store/slices/DescriptionTask';
import { fetchHardwareDescriptions } from '../../../store/slices/hardwareDescriptionSlice';
import { fetchWorkEntries } from '../../../store/slices/workentriesSlice';
import { useNavigate } from 'react-router-dom';
import { fetchGroups } from '../../../store/slices/groupSlice';

const ProjectCompleteWizard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { formatDateByCountry } = DateConversion();
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();
  const createdProject = useSelector((state) => state.wizardstep.createdProject);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { entries } = useSelector((state) => state.workentries);
  const operationProjectName = createdProject[0]?.ProjectName
  const { group: groups } = useSelector((state) => state.group);
  const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
  const wizardProjectState = useSelector((state) => state.wizardstep.wizardProjectState);
  const { matchedProject } = useMatchedProject(operationProjectName);

  const calculatedProjectData = useMatchedOperationsData(
    matchedProject[0]?.Projects || []
  );

  console.log("projectcomplete createdProject", createdProject)

  useEffect(() => {
    dispatch(setCurrentPageTitle("Project Completed"));
    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchGroups());
  }, [dispatch]);

  const groupNameById = React.useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = React.useCallback(
    (item) => {
      const groupId = item?.groupid?._id || item?.groupid;
      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }
      return item?.AssignedGroup || "";
    },
    [groupNameById]
  );

  const [rowName, setRowName] = useState(null)
  const [showListState, setShowListState] = useState("tasktable")
  const [rowID, setRowID] = useState(null)
  const [clickedProject, setClickedProject] = useState(null)
  const [currentProject, setCurrentProject] = useState({})
  const [clickedIdPerson, setClickedIdPerson] = useState(null)

  const handleleadread = async (row) => {
    const matchedLead = row
    if (!matchedLead) return;
    if (matchedLead.isRead === false) {
      const quotationId = matchedLead.quotationId;
      try {
        if (quotationId) await dispatch(setLeadReadTrue(quotationId));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        dispatch(fetchAllProjects())
      }
    }
  };


  const downloadPDFHardware = (newHardwareParts) => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "Sr. No",
          "Part Name",
          "Part Number",
          "Quantity",
          `Unit Price (${currency})`,
          `Total Price (${currency})`,
          "Start Date",
          "End Date",
        ],
      ],
      body: newHardwareParts?.map((LeadReport, index) => [
        index + 1,
        LeadReport.assemblepartdescription,
        LeadReport.partno,
        LeadReport.quantity,
        USAComma(LeadReport.unitprice),
        USAComma(LeadReport.totalprice),
        LeadReport.startdate
          ? formatDateByCountry(LeadReport.startdate)
          : "",
        LeadReport.enddate
          ? formatDateByCountry(LeadReport.enddate)
          : "",
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("Hardware PartList.pdf");
  };

  const downloadPDFHardwareDescriptions = (newDescriptions) => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Sr. No", "Description", `Amount (${currency})`, `Expenses (${currency})`, "Start Date", "End Date", "Notes"]],
      body: newDescriptions?.map((LeadReport, index) => [
        index + 1,
        LeadReport.description,
        formatAmountComma(LeadReport.value),
        formatAmountComma(LeadReport.expenses),
        LeadReport.startdate
          ? formatDateByCountry(LeadReport.startdate)
          : "",
        LeadReport.enddate
          ? formatDateByCountry(LeadReport.enddate)
          : "",
        LeadReport.notes,
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("Hardware OtherExpensesList.pdf");
  };

  const responseassignref = useRef(null);
  useEffect(() => {
    if ((rowName)) {
      // Scroll to the right end of the container
      const scrollToPosition = responseassignref.current.scrollWidth;
      responseassignref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowName]);

  return (
    <div>
      <div ref={responseassignref}
        className="w-[99%]  bg-white h-full  min-h-[20vh] max-h-[90vh] overflow-auto pb-5 ">
        <div className="w-full">
          <div
            className="sticky top-0 bg-[#E8E8E8]  z-[1299]">
            <div className="flex w-full bg-[#E8E8E8]  text-xs  text-center text-black">
              <div className={`font-semibold flex ${rowName ? "" : "w-[80%]"} `}>
                <div className="w-14 flex justify-center items-center">Sr. No</div>
                <div className={`${rowName ? "w-28" : "w-[20%]"}  p-2 break-words text-wrap flex justify-start items-center align-middle `}>
                  <span className='pl-3'>Group</span>
                </div>
                <div className={`${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-start items-center `}>
                  Client Name
                </div>
                <div className={`${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-start items-center align-middle `}>
                  Project Name
                </div>
                <div className={`${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                  Date {rowName && <br />}  Requested
                </div>
                <div className={`${rowName ? "w-28" : "w-[20%]"} p-2 break-words text-wrap flex justify-around items-center align-middle `}>
                  Due Date
                </div>
              </div>

              {rowName ? (
                <div className="flex w-full font-semibold">
                  <div className="w-36 flex shrink-0 bg-[#E8E8E8] p-2 break-words text-wrap justify-center items-center">
                    Manager Details
                  </div>
                  <div className="w-[36rem] bg-[#E8E8E8] break-words text-wrap">
                    <div className="w-full h-[50%] p-2 border break-words text-wrap flex justify-center items-center" >
                      Task Details
                    </div>
                    <div className="w-full h-[50%] border break-words text-wrap flex ">
                      <div
                        onClick={() => setShowListState("tasktable")}
                        className={`w-[50%] border-r-2 ${showListState === "tasktable" ? "bg-blue-500 text-white" : "text-black"} p-2 cursor-pointer flex justify-center items-center`}>
                        {clickedProject?.TypeService?.toLowerCase().includes("hardware") ? "Part List" : "Effort Expenses"}
                      </div>
                      <div
                        onClick={() => setShowListState("otherexpenses")}
                        className={`w-[50%] ${showListState === "otherexpenses" ? "bg-blue-500 text-white" : "text-black"} p-2 cursor-pointer flex justify-center items-center`}>
                        Other Expenses
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={`font-semibold w-[20%] bg-[#E8E8E8] p-2 flex justify-center items-center `}>
                  Input Details
                </div>
              )}
            </div>
          </div>

          <div className="">
            {matchedProject.map((row, index) => {
              const matchedData = calculatedProjectData?.find((data) => data?.ProjectName === row?.ProjectName);
              const matchedManagers = matchedData?.Projects?.filter((proj) => proj?.newProject?.isProjecttracking)
              return (
                <div
                  className={`flex text-xs ${row.isRead === false ? "font-bold" : " "} cursor-pointer group w-full`}
                  key={index}
                >
                  <div className={`flex ${rowName ? "" : "w-[80%]"} `}>
                    <div onClick={() => {
                      const isOpening = rowName === row?.ProjectName;
                      setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                      setRowID(rowID === row._id ? null : row._id);
                      setClickedProject(clickedProject === row ? null : row);
                      if (isOpening) {
                        handleleadread(row)
                      }
                    }}
                      className="w-14 border-b flex justify-start pl-2 items-center group-hover:bg-gray-100">
                      {index + 1}{" "}
                    </div>
                    <div onClick={() => {
                      const isOpening = rowName === row?.ProjectName;
                      setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                      setRowID(rowID === row._id ? null : row._id);
                      setClickedProject(clickedProject === row ? null : row);
                      if (isOpening) {
                        handleleadread(row)
                      }
                    }}
                      className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 flex justify-start align-middle items-center p-2 break-words text-wrap `}>
                      <span className='pl-3'>{getDisplayGroupName(row)}</span>
                    </div>
                    <div className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 p-2 flex justify-start align-middle items-center text-center break-words text-wrap `}>
                      {createdProject?.[0]?.ClientName}
                    </div>
                    <div onClick={() => {
                      const isOpening = rowName !== row?.ProjectName;
                      setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                      setRowID(rowID === row._id ? null : row._id);
                      setClickedProject(clickedProject === row ? null : row);
                      if (isOpening) {
                        handleleadread(row)
                      }
                    }}
                      className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100  flex justify-start align-middle items-center text-center p-2 break-words text-wrap overflow-hidden text-ellipsis line-clamp-2 break-all leading-snug text-xs `}>
                      {row.ProjectName}
                    </div>
                    <div onClick={() => {
                      const isOpening = rowName !== row?.ProjectName;
                      setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                      setRowID(rowID === row._id ? null : row._id);
                      setClickedProject(clickedProject === row ? null : row);
                      if (isOpening) {
                        handleleadread(row)
                      }
                    }}
                      className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100 flex justify-center align-middle items-center  p-2 break-words text-wrap `}>
                      {row.DateRequested &&
                        !isNaN(new Date(row.DateRequested))
                        ? formatDateByCountry(row.DateRequested)
                        : ""}
                    </div>
                    <div onClick={() => {
                      const isOpening = rowName !== row?.ProjectName;
                      setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                      setRowID(rowID === row._id ? null : row._id);
                      setClickedProject(clickedProject === row ? null : row);
                      if (isOpening) {
                        handleleadread(row)
                      }
                    }}
                      className={`${rowName ? "w-28" : "w-[20%]"} border-b group-hover:bg-gray-100  flex justify-center align-middle items-center  p-2 break-words text-wrap `}>
                      {row.ProjectDueDate &&
                        !isNaN(new Date(row.ProjectDueDate))
                        ? formatDateByCountry(row.ProjectDueDate)
                        : ""}
                    </div>
                  </div>

                  {rowName === row.ProjectName ? (
                    <div className=" flex flex-col group-hover:bg-gray-100 w-full">
                      {matchedManagers?.map((project, projectIndex) => (
                        <div
                          key={projectIndex}
                          className="w-full flex border-b border-gray-400"
                        >
                          <div className="w-full flex flex-col ">
                            {project.AssignedPersonData?.map((proj, index) => {
                              return (
                                <div key={index} className="w-full flex ">
                                  <div
                                    onClick={() => {
                                      setCurrentProject(currentProject === proj ? null : proj);
                                      setClickedIdPerson(clickedIdPerson === proj.empid ? null : proj.empid);
                                    }}
                                    className="w-36 flex flex-col justify-center items-center border-b p-2 break-words text-wrap text-center">
                                    <div
                                      className={`${clickedIdPerson === proj.empid ? "text-blue-500 " : "text-black"}px-2 py-1 rounded-md text-start`} >
                                      {proj.role === "project manager" && <>
                                        {proj.name}
                                      </>
                                      }
                                      <br />
                                      <span className="text-[11px]">
                                        {proj.role === "project manager" ? (
                                          <>
                                            ({proj.TypeService}{" "}
                                            {proj.role === "project manager" ? "Manager" : `Employee`}
                                            )
                                          </>
                                        ) : (
                                          <>
                                            {proj.TypeService}{" "}
                                            {proj.role === "project manager" ? "Manager" : `Employee ${index}`}

                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="w-[36rem] border-b p-2 break-words text-wrap">
                                    {clickedIdPerson === proj.empid ? (
                                      <>
                                        {proj?.TypeService?.toLowerCase().includes("hardware")
                                          ? showListState === "tasktable" && (
                                            <>
                                              <div
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                                className="w-full rounded-lg h-full justify-center pb-5"
                                              >
                                                <div className="w-full border border-gray-300  overflow-hidden">
                                                  <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px] font-semibold">
                                                    <div className="p-1 border-r  text-center">
                                                      Total Parts{" "}
                                                    </div>
                                                    <div className="p-1 border-r text-center">
                                                      Total Price ({currency})
                                                    </div>
                                                    <div className="p-1 text-center">Action</div>
                                                  </div>

                                                  <div className="grid grid-cols-3 bg-white text-black text-[11px]">
                                                    <div className="p-1 border-r border-blue-200 text-center">
                                                      {currentProject?.newHardwareParts?.length}
                                                    </div>
                                                    <div className="p-1 border-r border-blue-200 text-center">
                                                      {USAComma(
                                                        currentProject?.newHardwareParts?.reduce(
                                                          (sum, item) => {
                                                            return sum + (item.totalprice || 0);
                                                          },
                                                          0
                                                        )
                                                      )}{" "}
                                                    </div>
                                                    <div
                                                      title="Download Hardware Part List"
                                                      className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                      onClick={() =>
                                                        downloadPDFHardware(
                                                          currentProject?.newHardwareParts
                                                        )
                                                      }
                                                    >
                                                      Download
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )
                                          : showListState === "tasktable" && (
                                            <div className="w-full flex  gap-2">
                                              <div className="w-full max-h-[14rem] overflow-auto">
                                                <div className="sticky top-0 bg-[#1973eb] text-white text-[11px] text-center">
                                                  <div className="flex">
                                                    <div className="w-[21%] border p-1">Task</div>
                                                    <div className="w-[15%] border p-1">
                                                      Hrs Assigned
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      Hrs Spent
                                                    </div>
                                                    <div className="w-[17%] border p-1">
                                                      Start Date
                                                    </div>
                                                    <div className="w-[17%] border p-1">
                                                      End Date
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      Notes
                                                    </div>
                                                  </div>
                                                  <div className="flex bg-white text-black">
                                                    <div className="w-[21%] border p-1">
                                                      Total
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      {USAComma(
                                                        currentProject?.newworkEntries?.reduce(
                                                          (sum, item) => sum + item.hoursassigned,
                                                          0
                                                        ) || 0
                                                      )}
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      {USAComma(
                                                        currentProject?.newworkEntries?.reduce(
                                                          (sum, item) => sum + item.hoursspent,
                                                          0
                                                        ) || 0
                                                      )}
                                                    </div>
                                                    <div className="w-[17%] border p-1"></div>
                                                    <div className="w-[17%] border p-1"></div>
                                                    <div className="w-[15%] border p-1"></div>
                                                  </div>
                                                </div>
                                                {currentProject?.newworkEntries?.map((entry, index) => {
                                                  const matchedOldWorkEntry = entries.find(
                                                    (old) => old._id === entry.oldtaskid
                                                  );
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="flex text-center text-[11px]"
                                                    >
                                                      <div
                                                        className="w-[21%] border p-1 max-h-14 overflow-auto"
                                                        title={
                                                          matchedOldWorkEntry
                                                            ? `Previous Name: ${matchedOldWorkEntry.task}`
                                                            : ""
                                                        }
                                                      >
                                                        {entry.task}
                                                      </div>
                                                      <div
                                                        className="w-[15%] border p-1"
                                                        title={
                                                          matchedOldWorkEntry
                                                            ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                                            : ""
                                                        }
                                                      >
                                                        {entry.hoursassigned}
                                                      </div>
                                                      <div className="w-[15%] border p-1">
                                                        {entry.hoursspent || ""}
                                                      </div>
                                                      <div
                                                        className="w-[17%] border p-1 max-h-14 overflow-auto"
                                                      >
                                                        {entry.startdate
                                                          ? formatDateByCountry(entry.startdate)
                                                          : ""}
                                                      </div>
                                                      <div
                                                        className="w-[17%] border p-1 max-h-14 overflow-auto"
                                                      >
                                                        {entry.enddate
                                                          ? formatDateByCountry(entry.enddate)
                                                          : ""}
                                                      </div>
                                                      <div
                                                        className="w-[15%] border p-1 max-h-14 overflow-auto "
                                                        title={
                                                          matchedOldWorkEntry
                                                            ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                                            : ""
                                                        }
                                                      >
                                                        {entry.notes}
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          )}

                                        {showListState === "otherexpenses" &&
                                          (currentProject?.TypeService?.toLowerCase().includes("hardware") ? (
                                            // (currentProject?.TypeService === "Hardware" ? (
                                            <div className="w-full border border-gray-300 overflow-hidden">
                                              <div className="grid grid-cols-4 bg-blue-500 text-white text-[11px] font-semibold">
                                                <div className="p-1 border-r  text-center">
                                                  Total Descriptions{" "}
                                                </div>
                                                <div className="p-1 border-r text-center">
                                                  Amount ({currency})
                                                </div>
                                                <div className="p-1 border-r text-center">
                                                  Expenses ({currency})
                                                </div>
                                                <div className="p-1 text-center">Action</div>
                                              </div>

                                              <div className="grid grid-cols-4 bg-white text-black text-[11px]">
                                                <div className="p-1 border-r border-blue-200 text-center">
                                                  {currentProject?.newDescriptions?.length}
                                                </div>
                                                <div className="p-1 border-r border-blue-200 text-center">
                                                  {formatAmountComma(
                                                    currentProject?.newDescriptions?.reduce((sum, item) => {
                                                      return sum + (item.value || 0);
                                                    }, 0)
                                                  )}{" "}
                                                </div>
                                                <div className="p-1 border-r border-blue-200 text-center">
                                                  {formatAmountComma(
                                                    currentProject?.newDescriptions?.reduce((sum, item) => {
                                                      return sum + (item.expenses || 0);
                                                    }, 0)
                                                  )}{" "}
                                                </div>
                                                <div
                                                  title="Download Description List"
                                                  className="p-1 text-center cursor-pointer hover:bg-blue-50"
                                                  onClick={() =>
                                                    downloadPDFHardwareDescriptions(
                                                      currentProject?.newDescriptions
                                                    )
                                                  }
                                                >
                                                  Download
                                                </div>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="w-full flex  gap-2">
                                              <div className="w-full max-h-[14rem] overflow-auto">
                                                <div className="sticky top-0 bg-[#1973eb] text-white text-[11px] text-center">
                                                  <div className="flex">
                                                    {" "}
                                                    <div className="w-[21%] border p-1 truncate">
                                                      Description
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      Amount ({currency})
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      Expenses ({currency})
                                                    </div>
                                                    <div className="w-[17%] border p-1">
                                                      Start Date
                                                    </div>
                                                    <div className="w-[17%] border p-1">
                                                      End Date
                                                    </div>
                                                    <div className="w-[15%] border p-1">Notes</div>
                                                  </div>

                                                  <div className="flex bg-white text-black">
                                                    <div className="w-[21%] border p-1">Total</div>
                                                    <div className="w-[15%] border p-1">
                                                      {formatAmountComma(
                                                        currentProject?.newDescriptions?.reduce(
                                                          (sum, item) => sum + item.value,
                                                          0
                                                        ) || 0
                                                      )}
                                                    </div>
                                                    <div className="w-[15%] border p-1">
                                                      {formatAmountComma(
                                                        currentProject?.newDescriptions?.reduce(
                                                          (sum, item) => sum + item.value,
                                                          0
                                                        ) || 0
                                                      )}
                                                    </div>
                                                    <div className="w-[17%] border p-1"></div>
                                                    <div className="w-[17%] border p-1"></div>
                                                    <div className="w-[15%] border p-1"></div>
                                                  </div>
                                                </div>
                                                {currentProject?.newDescriptions?.map((description, index) => {
                                                  const matchedOldDescription = tasks.find(
                                                    (old) => old._id === description.oldtaskid
                                                  );
                                                  return (
                                                    <div
                                                      key={index}
                                                      className="flex text-center text-[11px]"
                                                    >
                                                      <div
                                                        className="w-[21%] border p-1 max-h-14 overflow-auto"
                                                        title={
                                                          matchedOldDescription
                                                            ? `Previous Name: ${matchedOldDescription.description}`
                                                            : ""
                                                        }
                                                      >
                                                        {description.description}
                                                      </div>
                                                      <div
                                                        className="w-[15%] border p-1"
                                                        title={
                                                          matchedOldDescription
                                                            ? `Previous Value: ${matchedOldDescription.value}`
                                                            : ""
                                                        }
                                                      >
                                                        {formatAmountComma(description.value)}
                                                      </div>
                                                      <div
                                                        className="w-[15%] border p-1"

                                                      >
                                                        {formatAmountComma(description.expenses)}
                                                      </div>
                                                      <div
                                                        className="w-[17%] border p-1 max-h-14 overflow-auto"
                                                      >
                                                        {description.startdate
                                                          ? formatDateByCountry(description.startdate)
                                                          : ""}
                                                      </div>
                                                      <div
                                                        className="w-[17%] border p-1 max-h-14 overflow-auto"
                                                      >
                                                        {description.enddate
                                                          ? formatDateByCountry(description.enddate)
                                                          : ""}
                                                      </div>
                                                      <div
                                                        className="w-[15%] border p-1 max-h-14 overflow-auto"
                                                        title={
                                                          matchedOldDescription
                                                            ? `Previous Note: ${matchedOldDescription.notes}`
                                                            : ""
                                                        }
                                                      >
                                                        {description.notes}
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          ))}
                                      </>
                                    ) : (
                                      <div
                                        onClick={() => {
                                          setCurrentProject(currentProject === proj ? null : proj);
                                          setClickedIdPerson(clickedIdPerson === proj.empid ? null : proj.empid);
                                        }}
                                        className="flex justify-center items-center h-full w-full cursor-pointer"> Task Details</div>
                                    )}

                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      onClick={() => setRowName(rowName === row.ProjectName ? null : row.ProjectName)}
                      className={`${rowName ? "" : "w-[20%]"} border-b  group-hover:bg-gray-100 cursor-pointer flex justify-center items-center`}
                    >
                      {rowName ? (
                        <div onClick={() => {
                          const isOpening = rowName !== row?.ProjectName;

                          setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="flex justify-center items-center">


                          <div className="w-36">
                          </div>
                          <div className="w-[36rem] pl-20">
                            Multiple
                          </div>
                        </div>
                      ) : (
                        <div onClick={() => {
                          const isOpening = rowName !== row?.ProjectName;

                          setRowName(rowName === row.ProjectName ? null : row.ProjectName);
                          setRowID(rowID === row._id ? null : row._id);
                          setClickedProject(clickedProject === row ? null : row);
                          if (isOpening) {
                            handleleadread(row)
                          }

                        }}
                          className="w-full  p-2 flex justify-center items-center">
                          Multiple
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

          </div>
        </div>
      </div>
      <div className='w-[99%] flex justify-end'>
        <div className="flex gap-4 pt-2">
          <button
            onClick={() => {
              dispatch(setCreatedProject(createdProject))
              dispatch(goToStep(1))
            }}
            className=" py-2 px-7 bg-black overflow-hidden shadow-md text-white rounded-lg"
          >
            Back
          </button>
          <button
            onClick={() => {
              if (wizardPlanState === "advancedplan" && wizardProjectState === "existingProject") {
                navigate("/dashboard");
                dispatch(clearWizardState())
                dispatch(setcurrentLeadID())
              } else {
              }
            }}

            className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
          >
            {wizardPlanState === "advancedplan" && wizardProjectState === "existingProject" ? "Save" : "Next"}
          </button>

        </div>
      </div>
    </div>
  )
}

export default ProjectCompleteWizard
